import { Routes } from "@angular/router";

export const taskRoutes: Routes = [
  {
    path: 'list', 
    loadComponent: () => import('./pages/list/list.component').then(m => m.ListComponent)
  },
  {
    path: 'list/:id', 
    loadComponent: () => import('./pages/programing/programing.component').then(m => m.ProgramingComponent)
  },
  {
    path: 'new', 
    loadComponent: () => import('./pages/programing/programing.component').then(m => m.ProgramingComponent)
  },
  { 
    path: '**', 
    redirectTo: 'list' 
  },
];